<template>
  <div class="deposit-method__pix-account">
    <div class="deposit-method__pix-data">
      <HeadingDisplay
        title=""
        avatar-type="image"
        avatar-content="371"
        avatar-alt=""
      >
        <template #title-component>
          <Heading :level="3">{{ props.pixInfo?.fantasyName }}</Heading>
        </template>
        <template #subtitle-component>
          <BaseText size="p6">{{ props.pixInfo?.companyName }}</BaseText>
        </template>
      </HeadingDisplay>
      <div class="deposit-method__pix-key">
        <div>
          <BaseText size="p4">Chave Pix</BaseText>
          <BaseText size="p4" :color="NebraskaColors.elementPrimary">{{
            props.pixInfo?.pixKey
          }}</BaseText>
        </div>
        <div><CopyButton :value="props.pixInfo?.pixKey" /></div>
      </div>
      <div class="deposit-method__pix-copypaste">
        <div>
          <BaseText size="p4">Pix copia e cola</BaseText>
          <BaseText
            class="deposit-method__pix-code"
            size="p4"
            :color="NebraskaColors.elementPrimary"
            >{{ props.pixInfo?.pixCopyPaste }}</BaseText
          >
        </div>
        <div><CopyButton :value="props.pixInfo?.pixCopyPaste" /></div>
      </div>
    </div>

    <img
      class="deposit-method__pix-image"
      :src="getQrCodeBase"
      alt="QR Code para depósito via PIX"
    />
  </div>
</template>
<script setup lang="ts">
import {
  HeadingDisplay,
  BaseText,
  CopyButton,
  Heading
} from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { IPixInfo } from '@/modules/cash/services/cash';
import { computed } from 'vue';

interface Props {
  pixInfo: IPixInfo | null;
}

const props = defineProps<Props>();

const getQrCodeBase = computed(() => {
  return `data:image/png;base64,${props.pixInfo?.pixQrCode}`;
});
</script>

<style lang="less" scoped>
.deposit-method {
  &__pix-account {
    display: flex;
    gap: @size-spacing-x500;

    .deposit-method__pix-data {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      @media @mobile {
        gap: @size-spacing-x300;
      }
    }

    .deposit-method__pix-image {
      max-width: 180px;
      flex: 1;

      @media @mobile {
        display: none;
      }
    }

    .deposit-method__pix-key,
    .deposit-method__pix-copypaste {
      display: flex;

      & > div {
        flex: 1;

        &:last-of-type {
          justify-content: flex-end;
          align-items: center;
          flex: 1;
          display: flex;
        }
      }
    }

    .deposit-method__pix-copypaste {
      display: none;

      @media @mobile {
        display: flex;
      }
    }

    .deposit-method__pix-code {
      width: 150px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
}
</style>
